







































/* eslint dot-notation: 0 */
import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { Action } from "vuex-class";
import { getChannelById } from "@/services/channels/channelsService";
import { bus } from "@/bus";
const namespace: string = "authentication";

@Component
export default class Header extends Vue {
    @Prop() IsNoPaddingLayout!: boolean;
    scroll: any;
    channelId: string = "";
    update = 0;
    breadCrumbs: any = null;
    displayBreadCrumbs: any = null;
    icon: string = "";
    scrollAmount = 0;

    // The style in the following 3 getters is set up in such a way, that they all increment by the same ratio every time.
    // That means the buttons will change from 50 -> 30 px height over the same amount of scroll distance as it takes
    // the app bar to change from 160 -> 50px height. The same happens with the breadcrumbs margin going from 100 -> 0px in that same scroll distance.
    buttonHeightMin = 30;
    buttonHeightMax = 50;
    buttonHeightDiff = this.buttonHeightMax - this.buttonHeightMin;
    headerHeightMin = 50;
    headerHeightMax = 160;
    headerHeightDiff = this.headerHeightMax - this.headerHeightMin;
    breadCrumbMargin = 100;

    get buttonStyle() {
        if (this.IsNoPaddingLayout) {
            return "height: " + this.buttonHeightMin + "px";
        }
        const currentSize = (this.buttonHeightMax - (Math.round((this.buttonHeightDiff / this.headerHeightDiff) * this.scrollAmount)));
        return `height: ${currentSize > this.buttonHeightMin ? currentSize : this.buttonHeightMin}px`;
    }

    get appBarStyle() {
        if (this.IsNoPaddingLayout) {
            return "height: " + this.headerHeightMin + "px";
        }
        const currentSize = (this.headerHeightMax - this.scrollAmount);
        return `height: ${currentSize > this.headerHeightMin ? currentSize : this.headerHeightMin}px`;
    }

    get breadCrumbStyle() {
        const currentMargin = Math.round((this.breadCrumbMargin / this.headerHeightDiff) * this.scrollAmount);
        return `margin-top: ${currentMargin < this.breadCrumbMargin ? this.breadCrumbMargin - currentMargin : 0}px`;
    }

    @Watch("$route", { immediate: true, deep: true }) RouteChanged() {
        this.update = 0;
        if (this.$route.meta.breadcrumbs !== undefined) {
            this.breadCrumbs = this.$route.meta.breadcrumbs.paths;
            this.displayBreadCrumbs = JSON.parse(JSON.stringify(this.breadCrumbs));
            this.icon = this.$route.meta.breadcrumbs.icon;

            for (let i = 0; i < this.breadCrumbs.length; i++) {
                const element = this.displayBreadCrumbs[i];
                var param = this.substringBetween(element[0], "/:", "/");
                if (param !== "" && param !== "/") {
                    if (this.$route.params[param] !== undefined) {
                        element[0] = element[0].replace(":" + param, this.$route.params[param]);
                    }
                }
                if (this.breadCrumbs[i][1] === ":channelName") {
                    this.displayBreadCrumbs[i][1] = "...";
                }
                bus.$on("breadCrumbsName", (name: string) => {
                    if (this.breadCrumbs[i] !== undefined) {
                        if (this.breadCrumbs[i][1] === ":channelName") {
                            this.displayBreadCrumbs[i][1] = name;
                            this.update++;
                        }
                    }
                });
            }
        } else {
            // If the breadcrumbs haven't been specified, let's just set it to nothing.
            this.breadCrumbs = null;
            this.icon = "";
        }
    }

    async fetchChannel() {
        if ((this.$route.params["channelId"]) !== undefined) {
            return await getChannelById(this.$route.params["channelId"]);
        }
    }

    substringBetween(s: string, a: string, b: string) {
        var p = s.indexOf(a) + a.length;
        return s.substring(p, s.indexOf(b, p));
    }

    mounted() {
        this.scroll = () => {
            var doc = document.documentElement;
            this.scrollAmount = (window.pageYOffset || doc.scrollTop) - (doc.clientTop || 0);
        };
        window.addEventListener("scroll", this.scroll, false);
    }

    beforeDestroy() {
        window.removeEventListener("scroll", this.scroll);
    }

    @Action("logoutAction", { namespace }) logoutAction: any;

    onLogout(): void {
        this.logoutAction();
        this.$router.push("/login");
    }
}
